import { AxiosError } from "axios";

import { config, getBaseUrl } from "@config";

import { errorCodes } from "@api/interceptors/constants";
import { InterceptorErrorHandler } from "@api/interceptors/types";

import { URLS } from "@constants/urls";

export const forbiddenWelcomeQuestionsNotAnswered: InterceptorErrorHandler = (
  error: AxiosError,
) => {
  const { response } = error;

  if (
    response?.status === 403 &&
    response?.data?._errors?.[0]?.id === errorCodes["403"].forbidden.welcomeQuestionsNotAnswered
  ) {
    if (!window.location.pathname.includes(URLS.onboardingWelcome)) {
      window.location.href = config.isDev()
        ? URLS.onboardingWelcome
        : `${getBaseUrl()}${URLS.onboardingWelcome}`;
    }
    return Promise.reject(error);
  }
  return error;
};
